import React from "react";
import { toast } from "sonner";
import { residentApi, errMsg } from "@/lib/api";
import { dateLabel } from "@/lib/format";
import { Card } from "@/components/common";
import { useResidentApi } from "@/pages/resident/useResidentApi";

const CLS: Record<string, string> = {
  pending: "bg-amber-50 text-amber-800 border-amber-200", accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  declined: "bg-rose-50 text-rose-700 border-rose-200", cancelled: "bg-slate-50 text-slate-500 border-slate-200",
};

export function MyRequests() {
  const { data, reload } = useResidentApi<any[]>("/resident/join-requests");
  if (!data?.length) return null;
  const cancel = async (id: string) => {
    try { await residentApi.delete(`/resident/join-requests/${id}`); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card className="p-4" data-testid="resident-my-requests">
      <p className="font-bold mb-2">My join requests</p>
      {data.map((j) => (
        <div key={j.id} className="py-2.5 border-b border-slate-100 last:border-0 flex items-center justify-between gap-2" data-testid={`join-request-${j.id}`}>
          <div className="min-w-0">
            <p className="font-semibold truncate">{j.property_name}</p>
            <p className="text-xs text-slate-500">{j.room_name ? `Room ${j.room_name} · ` : ""}Move-in {dateLabel(j.move_in_date)}</p>
          </div>
          <div className="flex items-center gap-2">
            <span data-testid={`join-status-${j.id}`} className={`text-xs font-semibold rounded-full border px-2.5 py-1 capitalize ${CLS[j.status]}`}>{j.status}</span>
            {j.status === "pending" && <button data-testid={`join-cancel-${j.id}`} onClick={() => cancel(j.id)} className="text-xs font-semibold text-slate-500 underline">Cancel</button>}
          </div>
        </div>
      ))}
    </Card>
  );
}
